export default function sortingAlpha(response: any[]) {
  return response.sort((a: { label: string }, b: { label: string }) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  });
}
